export default __webpack_public_path__ + "static/media/logo2.52a41eb1.svg";